module.exports = __webpack_public_path__ + "static/media/sellacar265x250.ad0585ba.png";